import { useEffect, useState } from 'react';
import { loadWorkspaceBackground, parseManagedBackground } from './workspaceBackgroundService';

export default function useResolvedBackgroundUrl(value) {
  const [resolved, setResolved] = useState(() => (
    parseManagedBackground(value) ? '' : (value || '')
  ));

  useEffect(() => {
    const managed = parseManagedBackground(value);
    if (!managed) {
      setResolved(value || '');
      return undefined;
    }
    let cancelled = false;
    let objectUrl = '';
    loadWorkspaceBackground(managed.workspaceId, managed.assetId)
      .then((blob) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(blob);
        setResolved(objectUrl);
      })
      .catch(() => {
        if (!cancelled) setResolved('');
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [value]);

  return resolved;
}
